export default function ($request, { $ext, env }) {
	return {
		/*配置*/
		config: $request.get('/comm/config/web', {
			response({
				domainName,
				imageDomainName,
				serviceProjectName
			}, next) {
				next({
					origin: domainName,
					image: imageDomainName,
					service: serviceProjectName
				});
			}
		}),
		/*活动*/
		activity: $request.get('/activity/meals/find', {
			request(data, next) {
				next(env.activity);
			}
		}),
		/*用户*/
		user: {
			/*信息*/
			info: $request.get('/member/information/find'),
			/*登录*/
			login: $request.post('/passport/login/submit', {
				request(data, next, error) {
					$ext.validate(data, {
						loginName: "请输入账号",
						loginPasswd: "请输入密码"
					})
						.then(o => next(o))
						.catch(e => error(e));
				}
			}),
			/*注销*/
			logout: $request.post('/passport/logout/submit'),
			/*消息*/
			msg: {
				/*列表*/
				list: $request.get('/member/msg/list'),
				/*读取消息*/
				read: $request.put('/member/msg/read'),
				/*删除消息*/
				remove: $request.delete('/member/msg/remove'),
				/*清除站内已读消息*/
				clear: $request.delete('/member/msg/remove4read'),
				/*未读消息数量*/
				unread: $request.get('/member/msg/unread')
			},
			/*修改密码*/
			pwd: $request.put('/member/account/passwd'),
			/*接受邀请*/
			apply: $request.post('/activity/meals/rater-invite')
		},
		/*菜肴*/
		recipe: {
			/*列表*/
			list: $request.get('/goods/dishes/list'),
			/*信息*/
			info: $request.get('/goods/dishes/custom'),
			/*添加*/
			add: $request.post('/goods/dishes/custom'),
			/*修改*/
			edit: $request.put('/goods/dishes/custom'),
			/*删除*/
			remove: $request.delete('/goods/dishes/custom'),
			/*查找*/
			find: $request.get('/goods/dishes/find'),
			/*搜索*/
			search: $request.get('/goods/merge/search')
		},
		/*食物*/
		food: {
			/*查找*/
			find: $request.get('/goods/food/find'),
			/*搜索*/
			search: $request.get('/goods/food/search'),
			/*根据分类查询食物列表*/
			list: $request.get('/goods/food/find4classify'),
		},
		/*字典*/
		map: {
			/*食物分类*/
			classify: $request.get('/goods/dictionary/classify', {
				response(data, next) {
					function unfold(target, parent) {
						return target.reduce((p, { code, name, childArray }) => {
							p.push({ code, name, parent }, ...unfold(childArray, code));
							return p;
						}, []);
					}
					next(unfold(data));
				}
			}),
			/*营养成分*/
			nutrition: $request.get('/goods/dictionary/nutrition')
		},
		/*比赛*/
		competition: {
			/*作品集*/
			list: $request.get('/activity/meals/competition-list', {
				response(data, next) {
					next(data || []);
				}
			}),
			/*待评审列表*/
			waitList: $request.get('/activity/meals/competition-list-reviewer'),
			/*添加*/
			add: $request.post('/activity/meals/competition'),
			/*更新*/
			update: $request.put('/activity/meals/competition'),
			/*提交*/
			submit: $request.put('/activity/meals/submit'),
			/*配餐作品*/
			meal: {
				/*信息*/
				info: $request.get('/activity/meals/competition'),
				/*详情*/
				detail: $request.get('/activity/meals/competition-opus', {
					response(data, next) {
						next(Object.assign(data, {
							dishesArray: (data.dishesArray || []).sort((a, b) => a.dishesOrder < b.dishesOrder ? -1 : 1)
						}));
					}
				}),
				/*添加*/
				add: $request.post('/activity/meals/competition-opus', {
					request(data, next, error) {
						$ext.validate(data, {
							dishesArray: { minLength: 1, message: "请至少添加一份配餐" }
						})
							.then(o => next(o))
							.catch(e => error(e));
					}
				}),
			},
			/*评审*/
			review: {
				/*信息*/
				info: $request.get('/activity/meals/competition-reviewer'),
				/*详情*/
				detail: $request.get('/activity/meals/competition-opus-reviewer'),
				/*提交*/
				submit: $request.post('/activity/meals/review', {
					request(data, next, error) {
						$ext.validate(data, {
							socreArray: {
								each(o, i) {
									return parseFloat(o.angleScore) >= 0;
								},
								message: "评分内容不正确"
							},
							remarks: "请输入综合点评"
						}).then(o => next(o))
							.catch(e => error(e));
					}
				})
			}
		},
		/*配餐指导*/
		guide: $request.get('/melas/guide/find', {
			response(data, next) {
				data.classifyGuideArray = data.classifyGuideArray.sort(
					(a, b) => a.classifyCalorie > b.classifyCalorie ? -1 : 1
				);
				next(data);
			}
		}),
		/*获取上传凭证*/
		sign: $request.get('/comm/image/signature', {
			response({
				action,
				key,
				policy,
				signature,
				ossaccessKeyId
			}, next) {
				next({
					action,
					key,
					policy,
					Signature: signature,
					OSSAccessKeyId: ossaccessKeyId,
				});
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/config/actions.js